import React, { useContext } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import Carousel from '../../carousel/Carousel';
import { openLink } from '../../util/utilNative';
import IconVideo from '../../../asset/img/ico_video.svg';
// import MoreIcon from "../../../asset/img/ic_list_arrow_nor.svg";

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.5px',
    margin: '6px 0px',
    zIndex: 11,
  },
  carousel: {
    width: '100%',
    height: '144px',
  },
  listitem: {
    // width: "298px",
    padding: '0px 8px 0px px',
    margin: '0 0 8px 0',
  },
  cardContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    display: 'flex',
    // marginRight: "8px",
    background: '#fff',
    // border: "1px solid #d7d7d7",
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: '6px',
    textAlign: 'center',
    // cursor: 'pointer',
    padding: '16px',
    margin: '0 6px 16px 0',
    position: 'relative',
  },
  indexBoxContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '0 4px',
  },
  infoHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "0 4px",
    margin: '0 0 8px 0',
  },
  indexBox: {
    fontSize: theme.font.size15,
    fontWeight: '900',
    textAlign: 'start',
    // color: theme.color.accent,
    color: theme.color.text_color.red,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.08',
    letterSpacing: 'normal',
  },
  horizontalDivider: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.color.divider.grey,
  },
  info: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  infoTitleBox: {
    width: '100%',
    // height: "3rem",
    flexGrow: 1,
  },
  infoTitle: {
    fontSize: theme.font.size15, // "15px",
    color: theme.color.text_color.black,
    fontWeight: 'bold',
    textAlign: 'start',
    overflow: 'hidden',
  },
  videoIconButton: {
    background: 'none',
    border: 'none',
  },
  videoIcon: {
    width: '1rem',
    verticalAlign: 'middle',
    // margin: "0 0 0 3px",
  },
  infoDescription: {
    fontSize: theme.font.size14,
    color: theme.color.text_color.grey,
    textAlign: 'start',
    padding: '15.5px 4px 16px 4px',
    flexGrow: 1,
  },
  moreButton: {
    height: '40px',
    fontSize: theme.font.size14,
    color: theme.color.button.text_black,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 10px',
    background: theme.color.button.background_grey,
    borderRadius: '6px',
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
    // outline: '0 none',
    border: '0px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1.43',
    cursor: 'pointer',
  },
});

const CLCard = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const MAX_SUMMARY_STR_LENGNTH = 65;

  const handleClick = (item) => {
    if (ref.clickAllowed()) {
      console.log(item.url);
      openLink(context, item.type, item.url, item.event_action, true);
    }
  };
  const Card = ({ item, index, max, ellipsis }) => {
    let summaryStr = item?.summary || '';

    if (ellipsis && summaryStr.length > MAX_SUMMARY_STR_LENGNTH) {
      summaryStr = summaryStr.substring(0, MAX_SUMMARY_STR_LENGNTH - 3) + '...';
    }
    return (
      <div className={classes.card}>
        <div
          className={classes.cardContainer}
          // onClick={() => handleClick(item)}
          aria-label={`Q${index + 1}, ${item.title}, ${summaryStr}, 자세히 보기, ${
            index + 1
          }/${max}, 항목${max}개`}
          // tabIndex={0}
          // role={'button'}
        >
          <div className={classes.indexBoxContainer}>
            <div className={classes.infoHeader}>
              <div className={classes.indexBox}>{'Q' + (index + 1)}</div>
              {item.video_yn === 'Y' && (
                <button
                  className={classes.videoIconButton}
                  onClick={() => handleClick(item)}
                  title="새창열림"
                >
                  <img
                    className={classes.videoIcon}
                    src={IconVideo}
                    alt={'해결방법 영상보기'}
                  />
                </button>
              )}
            </div>
            <div className={classes.infoTitleBox}>
              <div className={classes.infoTitle}>{item.title}</div>
            </div>
          </div>
          <Divider
            orientation={'horizontal'}
            className={classes.horizontalDivider}
            component={'div'}
            disabled
          />
          <div className={classes.info}>
            <div className={classes.infoDescription}>{summaryStr}</div>
            <button
              type="button"
              className={classes.moreButton}
              onClick={() => handleClick(item)}
            >
              더보기
            </button>
          </div>
        </div>
      </div>
    );
  };
  return data.list_items.map((item, index) => (
    <div key={index} className={classes.listitem}>
      <Card
        key={index}
        item={item}
        index={index}
        max={data.list_items.length}
        ellipsis={data.ellipsis !== 'N'}
      />
    </div>
  ));
});

function CL(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <div className={classes.root}>
      {/* Card Carousel */}
      <Carousel
        className={classes.carousel}
        component={withStyles(styles)(CLCard)}
        data={data}
        ariaLabe={context.string.aria.content}
      />
    </div>
  );
}
export default withStyles(styles)(CL);
